import React from "react";

export default function Alerts({ msg }) {
  return (
    <div className="alert alert-info" role="alert">
      {msg}
    </div>
  );
}
